import React from 'react';
import { Routes, Route } from 'react-router-dom';
import LandingPage from '@/components/LandingPage';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import TermsAndConditions from '@/pages/TermsAndConditions';
import PostDetails from '@/pages/PostDetails';
import NotFound from '@/pages/NotFound';
import '@/App.css';

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
      <Route path="/post/:id" element={<PostDetails />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default App;